export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "da02d50.worker.js");
}
